(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("phaser"));
	else if(typeof define === 'function' && define.amd)
		define(["phaser"], factory);
	else if(typeof exports === 'object')
		exports["PhaserNavMeshPlugin"] = factory(require("phaser"));
	else
		root["PhaserNavMeshPlugin"] = factory(root["Phaser"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__445__) {
return 